var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03_\u540E\u53F0\u83DC\u5355\u7BA1\u7406") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.05,12a7,7,0,0,1,7,7v7H19a7,7,0,0,1-7-7V19a7,7,0,0,1,7-7h.08m0-4H19A11,11,0,0,0,8,19V19A11,11,0,0,0,19,30h9a2,2,0,0,0,2-2V19a11,11,0,0,0-11-11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.05,12a7,7,0,0,1,7,7V19a7,7,0,0,1-7,7H38V19a7,7,0,0,1,7-7h.08m0-4H45A11,11,0,0,0,34,19v9a2,2,0,0,0,2,2h9A11,11,0,0,0,56,19V19a11,11,0,0,0-11-11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26,38v7a7,7,0,0,1-7,7H19a7,7,0,0,1-7-7V45a7,7,0,0,1,7-7h7m2-4H19A11,11,0,0,0,8,45V45A11,11,0,0,0,19,56h.08A11,11,0,0,0,30,45V36a2,2,0,0,0-2-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.05,38a7,7,0,0,1,7,7V45a7,7,0,0,1-7,7H45a7,7,0,0,1-7-7V38h7m0-4H36a2,2,0,0,0-2,2v9A11,11,0,0,0,45,56h.08A11,11,0,0,0,56,45V45a11,11,0,0,0-11-11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.35ce8e29.svg";
export { ForwardRef as ReactComponent };